import React from 'react';
import {
  FaLeaf,
  FaChartLine,
  FaMapMarkerAlt,
  FaCogs,
  FaArrowRight,
  FaCheckCircle,
} from 'react-icons/fa';

const Agriculture = () => {
  const features = [
    {
      icon: <FaChartLine />,
      title: 'Optimisation de la productivité',
      text: 'Solutions technologiques pour améliorer les rendements agricoles et optimiser l\'utilisation des ressources.',
    },
    {
      icon: <FaMapMarkerAlt />,
      title: 'Suivi des exploitations',
      text: 'Géolocalisation et suivi en temps réel des activités agricoles pour une meilleure gestion des parcelles.',
    },
    {
      icon: <FaCogs />,
      title: 'Automatisation des processus',
      text: 'Digitalisation des opérations agricoles, de la planification à la récolte, pour plus d\'efficacité.',
    },
  ];

  const benefits = [
    'Modernisation des pratiques agricoles',
    'Réduction des coûts de production',
    'Amélioration de la traçabilité',
    'Accès aux données en temps réel',
    'Aide à la décision pour les agriculteurs',
    'Valorisation des produits agricoles',
  ];

  return (
    <section id="agriculture" className="agriculture section">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">Agriculture & Agrotech</span>
          <h2 className="section-title">Moderniser l'agriculture par la technologie</h2>
          <p className="section-subtitle">
            Livia Tech développe des solutions technologiques innovantes pour accompagner
            la transformation du secteur agricole en Afrique. De la gestion des exploitations
            à la traçabilité des produits, nous mettons l'innovation au service de l'agriculture.
          </p>
        </div>

        <div className="agriculture-content">
          <div className="agriculture-visual">
            <div className="agriculture-image-wrapper">
              <img
                src="/images/agri.jpeg"
                alt="Agriculture et technologies agricoles - Livia Tech"
                className="agriculture-image"
                loading="lazy"
              />
              <div className="agriculture-image-overlay"></div>
              <div className="agriculture-visual-badge">
                <FaLeaf />
                <span>Agrotech & Innovation</span>
              </div>
            </div>
          </div>

          <div className="agriculture-info">
            <h3>Des solutions adaptées aux réalités africaines</h3>
            <p>
              Notre approche combine technologie, expertise agricole et connaissance du terrain
              pour proposer des outils accessibles et efficaces. Nous accompagnons les agriculteurs,
              les coopératives et les entreprises agricoles dans leur transformation digitale.
            </p>
            <div className="agriculture-features">
              {features.map((feature, index) => (
                <div className="agriculture-feature" key={index}>
                  <div className="agriculture-feature-icon">{feature.icon}</div>
                  <div className="agriculture-feature-content">
                    <h4>{feature.title}</h4>
                    <p>{feature.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="agriculture-benefits">
          <h3>Avantages de nos solutions agricoles</h3>
          <div className="agriculture-benefits-grid">
            {benefits.map((benefit, index) => (
              <div className="agriculture-benefit" key={index}>
                <FaCheckCircle className="agriculture-benefit-icon" />
                <span>{benefit}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="agriculture-cta">
          <p>Vous souhaitez moderniser votre exploitation agricole ou votre coopérative ?</p>
          <a href="#contact" className="btn btn-primary btn-lg">
            Discutons de votre projet <FaArrowRight className="btn-icon" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Agriculture;